import { MESSENGER_URL } from './constant'
import { isMobile } from 'react-device-detect'

export const showFBChat = () => {
  if (isMobile) {
    window.open(MESSENGER_URL, '_blank')
  } else if (window.FB && window.FB.Event) {
    window.FB.CustomerChat.showDialog()
  }
}
export const subscribeFB = (event, handle) => {
  if (window.FB && window.FB.Event) {
    window.FB.Event.subscribe(event, handle)
  }
}
